module.exports = "pegasus_template/assets/blocks/image-4-theme6.png";